<template>
    <div class="modal">
        <b-modal id="create_fulfilment" centered hide-footer size="lg" scrollable title="Create Fulfilment">
            <div class="overlay" v-show="isLoading">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>
            <div class="popup text-left">
                <div class="content create-workform bg-body">
                    <div class="table-responsive-sm">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Item</th>
                                    <th class="text-center" scope="col">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in orderInfo" :key="index">
                                    <td>
                                        <h6 class="mb-0">{{ item.name }}</h6>
                                        <p class="mb-0">{{ item.sku }}
                                        </p>
                                    </td>
                                    <td class="text-center">
                                        <select name="" id="input" class="form-control" v-model="item.qty_to_ship">
                                            <option :value="0">None</option>
                                            <option v-for="n in item.qty_ordered" :key="n" :value="(n)">{{ n }} of {{
                                                    item.qty_ordered
                                            }}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <b-alert :show="true" variant="secondary" class="bg-white">
                        <div class="iq-alert-icon">
                            <i class="ri-information-line"></i>
                        </div>
                        <div class="iq-alert-text">We recommend adding your courier tracking number to this order. This
                            will be emailed to your customer.</div>
                    </b-alert>
                    <div class="col-lg-12 mt-4">
                        <div class="form-group col-sm-12"><label>Courier:</label><select v-model="trackingInfo.courier" id="selectcountry"
                                class="form-control">
                                <option>Select Courier</option>
                                <option>Aramex</option>
                                <option>DHL</option>
                                <option>DPD</option>
                                <option>Other</option>
                            </select></div>
                        <div class="form-group col-sm-12"><label for="fname">Tracking Number:</label><input v-model="trackingInfo.tracking_no" type="text"
                                id="fname" placeholder="Tracking Number" class="form-control"></div>
                        <div class="d-flex mt-4 flex-wrap align-items-ceter justify-content-end">
                            <div class="btn btn-primary mr-4" data-dismiss="modal" @click="createShipment()">
                                Create Fulfilment</div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "cancelOrder",
    computed: {
        orderInfo() {
            return this.$store.state.invoices.newInvoice
        },
        isLoading() {
            return this.$store.state.orders.saving
        },
        trackingInfo() {
            return this.$store.state.invoices.trackingInfo[0]
        },
        orderShipping() {
            return this.$store.state.orders.order.shipping_incl_tax
        },
        totalItem: function () {
            let sum = 0;
            for (let i = 0; i < this.orderInfo.length; i++) {
                sum += (parseFloat(this.orderInfo[i].price_incl_tax) * parseFloat(this.orderInfo[i].qty_to_ship));
            }

            return sum;
        }
    },
    methods: {
        getLineTotal(item) {
            return item.qty_to_ship * item.price
        },
        calculateTotals() {
            const orderInfo = this.orderInfo
            return orderInfo.reduce((n, { price }) => n + price, 0)
        },
        async createShipment() {
            // const shouldCreateShipment = this.$refs['paymentMethod'].createShipment;
            let items = this.orderInfo.map(function (item) {
                return {
                    order_item_id: item.item_id,
                    qty: item.qty_to_ship,
                };
            })
            const payload = {
                entity: {
                    items,
                    notify: true,
                    appendComment: false,
                    arguments: {
                        extension_attributes: {
                            source_code: "demo"
                        }
                    }
                },
            };
            await this.$store.dispatch('createShipment', { payload, orderId: this.$route.params.id });
  
        },
    },
    beforeMount() {
    },
    beforeDestroy() {
        this.$store.commit('invoices/setNewShipment', {
            data: ''
        });
    }
}
</script>
<style lang="scss">
.overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    background: rgba(21,26,48,0.3);
    backdrop-filter: blur(5px);
}

.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}

.spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(255, 255, 255, 0.05);
    border-top-color: #fff;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>